export const titleConfig = {
  small: {
    textSize: "text-xl",
    fontWeight: "font-semibold",
  },
  medium: {
    textSize: "text-2xl",
    fontWeight: "font-bold",
  },
  large: {
    textSize: "text-3xl",
    fontWeight: "font-bold",
  },
};
